export default class {
    constructor (lodash, QUESTIONS_CONFIRM_ENUM) {
        this.lodash = lodash;
        this.QUESTIONS_CONFIRM_ENUM = QUESTIONS_CONFIRM_ENUM;
    }

    getConfirmationMessage (response) {
        const { lodash, QUESTIONS_CONFIRM_ENUM } = this;
        const fields = lodash.map(response.data, error => error.field);
        let msg = false;
        if (lodash.includes(fields, QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_SURVEY_OR_FEEDBACK)) {
            msg = QUESTIONS_CONFIRM_ENUM.LABELS.CONFIRM_HAS_SURVEY_OR_FEEDBACK;
        }
        else if (lodash.includes(fields, QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_QUIZ)) {
            msg = QUESTIONS_CONFIRM_ENUM.LABELS.CONFIRM_HAS_QUIZ;
        }
        else if (lodash.includes(fields, QUESTIONS_CONFIRM_ENUM.KEYS.CONFIRM_HAS_FORM)) {
            msg = QUESTIONS_CONFIRM_ENUM.LABELS.CONFIRM_HAS_FORM;
        }
        return msg;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question/confirm/index.js